// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-react-tabs {
    width: 80rem;
}
.add-admin-container {
    display: flex;
    justify-content: end;
}
.course-list {
    margin-top: 20px;
}
.table-list {
    margin-top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/Admin.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB","sourcesContent":[".admin-react-tabs {\n    width: 80rem;\n}\n.add-admin-container {\n    display: flex;\n    justify-content: end;\n}\n.course-list {\n    margin-top: 20px;\n}\n.table-list {\n    margin-top: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
